import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const Rating = ({ value, text, color = '#f8e825' }) => {
  const totalStars = 5;
  const fullStars = Math.floor(value);
  const hasHalfStar = value - fullStars >= 0.5;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {[...Array(totalStars)].map((_, index) => (
        <StarIcon key={index} sx={{ color: index < value ? color : 'grey.300' }} />
      ))}
      {text && <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>{text}</Typography>}
    </Box>
  );
};

export default Rating;